function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clone } from 'ramda';
import { constantsRegistry } from '../../constants/tableConstantsFactory';
import entityReducerFactory from './entityReducerFactory';

// REDUCER METHODS

const show = state => _objectSpread(_objectSpread({}, state), {}, {
  loading: true
});
const showCancel = state => _objectSpread(_objectSpread({}, state), {}, {
  active: {},
  originalActive: {},
  pendingChanges: false
});
const showFail = (state, action) => _objectSpread(_objectSpread({}, state), {}, {
  active: {},
  error: action.payload || {
    message: 'failed fetching'
  },
  loading: false
});
const showSuccess = (state, action) => {
  const active = Array.isArray(action.data) ? action.data[0] : action.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    active,
    originalActive: clone(action.data),
    pendingChanges: false,
    loading: false
  });
};
export default function detailReducerFactory(entity) {
  const constants = constantsRegistry(entity);
  const entityReducers = entityReducerFactory(entity);
  const initState = _objectSpread(_objectSpread({}, entityReducers.initState), {}, {
    active: {},
    originalActive: {}
  });
  const reducers = {
    [constants.SHOW]: show,
    [constants.SHOW_CANCEL]: showCancel,
    [constants.SHOW_FAIL]: showFail,
    [constants.SHOW_SUCCESS]: showSuccess
  };

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers,
    initState
  };
}